angular.module('impactx.sso').controller('OpenIdSettingsCtrl', [
    '$scope',
    'dataGen',
    'ToastService',
    'ToolbarService',
    'TranslationService',
    OpenIdSettingsCtrl]);

function OpenIdSettingsCtrl($scope, dataGen, ToastService, ToolbarService, TranslationService) {
    var self = this;
    dataGen.getData($scope, {}, "/login/openid/settings").then(function () {
        defineButtons();
    });

    self.refresh = function () {
        return dataGen.postAsForm($scope, {settings: $scope.data}, "/login/openid/settings/refresh").then(function () {
            if ($scope.data && !$scope.data.noAuthenticator) {
                ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            }
        })
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.refreshData,
                action: self.refresh,
                type: 'dialogaction',
                condition: canRefresh
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function canRefresh() {
        return $scope.data && $scope.data.discoveryURL && !$scope.data.noAuthenticator;
    }
}